import Router from 'vue-router'
import SpaceDashboard from './components/SpaceDashboard'
import SpaceDashboardContent from './components/SpaceDashboardContent'
import SpaceDashboardCrudEntry from './components/SpaceDashboardCrudEntry'
import SpaceDashboardMedia from './components/SpaceDashboardMedia'
import SpaceDashboardCrudMedia from './components/SpaceDashboardCrudMedia'
import ReorderContent from './components/ReorderContent'
import AddMultipleMedia from './components/AddMultipleMedia'
import SettingsDeliveryKey from './components/SettingsAPIKeys'
import SettingsUsers from './components/SettingsUsers'
import Login from './components/Login'

import store from './store'
import {
    GET_SESSION_TOKEN,
    SET_SESSION_TOKEN,
    LOGIN_COOKIE_KEY
} from './services/constants'
import Vue from 'vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            name: 'spaceDashboardRoot',
            path: '/:spaceIdentifier/u',
            component: SpaceDashboard,
            beforeEnter: (to, from, next) => {
                loggedInGuard(to, from, next)
            },
            beforeRouteLeave(to, from, next) {
                logOut(to, from, next)
            },
            children: [
                {
                    name: 'spaceDashboardContent',
                    path: 'content',
                    component: SpaceDashboardContent,
                    beforeEnter: (to, from, next) => {
                        loggedInGuard(to, from, next)
                    }
                },
                {
                    name: 'spaceDashboardMedia',
                    path: 'media',
                    component: SpaceDashboardMedia,
                    beforeEnter: (to, from, next) => {
                        loggedInGuard(to, from, next)
                    }
                },
                {
                    name: 'spaceDashboardAddMedia',
                    path: 'media/add',
                    component: SpaceDashboardCrudMedia,
                    beforeEnter: (to, from, next) => {
                        loggedInGuard(to, from, next)
                    }
                },
                {
                    name: 'addMultipleMedia',
                    path: 'media/add/multiple',
                    component: AddMultipleMedia,
                },
                {
                    name: 'spaceDashboardEditMedia',
                    path: 'media/edit/:id',
                    component: SpaceDashboardCrudMedia,
                    beforeEnter: (to, from, next) => {
                        loggedInGuard(to, from, next)
                    }
                },
                {
                    name: 'spaceDashboardAddEntry',
                    path: 'add/:contentTypeIdentifier',
                    component: SpaceDashboardCrudEntry,
                    beforeEnter: (to, from, next) => {
                        loggedInGuard(to, from, next)
                    }
                },
                {
                    name: 'spaceDashboardEditEntryLocale',
                    path: 'edit/:contentTypeIdentifier/:id/:locale',
                    component: SpaceDashboardCrudEntry,
                    beforeEnter: (to, from, next) => {
                        loggedInGuard(to, from, next)
                    }
                },
                {
                    name: 'spaceDashboardEditEntry',
                    path: 'edit/:contentTypeIdentifier/:id/',
                    component: SpaceDashboardCrudEntry,
                    beforeEnter: (to, from, next) => {
                        loggedInGuard(to, from, next)
                    }
                },
                {
                    name: 'reorderContent',
                    path: 'reorder/:contentTypeIdentifier/',
                    component: ReorderContent,
                    beforeEnter: (to, from, next) => {
                        loggedInGuard(to, from, next)
                    }
                },
                {
                    name: 'settingsAPIKeys',
                    path: 'settings/api',
                    component: SettingsDeliveryKey,
                    beforeEnter: (to, from, next) => {
                        loggedInGuard(to, from, next)
                    }
                },
                {
                    name: 'settingsUsers',
                    path: 'settings/users',
                    component: SettingsUsers,
                    beforeEnter: (to, from, next) => {
                        loggedInGuard(to, from, next)
                    }
                },
                {
                    path: '',
                    redirect: {name: 'spaceDashboardContent'}
                }
            ]
        },

        {
            name: 'login',
            path: '/:spaceIdentifier',
            component: Login,
            beforeEnter: (to, from, next) => {
                initialRedirect(to, from, next)
            },
        },

    ]
})

function initialRedirect(to, from, next) {
    store.getters[GET_SESSION_TOKEN] ? next({path: `${to.path}/u`,}) : next()
}

function loggedInGuard(to, from, next) {
    store.getters[GET_SESSION_TOKEN] ? next() : next({path: to.params['spaceIdentifier']})
}

function logOut(to, from, next) {
    this.$store.commit(SET_SESSION_TOKEN, {
        [LOGIN_COOKIE_KEY]: null,
    });
    next()
}
